// extracted by mini-css-extract-plugin
export default {"container":"BookCard_container__dVYCJ","clickable":"BookCard_clickable__jT3ty","cover":"BookCard_cover__NhoYK","info":"BookCard_info__JvKCm","points":"BookCard_points__lQfdX"};